import Pagination     from "../../../domain/fundamentals/pagination/Pagination";
import Plan           from "../../../domain/plan/Plan";
import PlanId         from "../../../domain/plan/PlanId";
import PlanRepository from "../../../domain/plan/PlanRepository";
import Plans          from "../../../domain/plan/Plans";
import PlanStatusType
                      from "../../../domain/plan/PlanStatusType";
import ReservationId  from "../../../domain/reservation/ReservationId";
import {
  apiDeletePlan, apiGetPlanReservationId,
  apiGetPlans,
  apiGetPlansCount,
  apiPostPlan,
  apiPutPlan,
  apiPutPlanStatus
} from "../../api/plan";

class PlanDataSource implements PlanRepository {
  async findByPage(pagination: Pagination): Promise<{plans: Plans, pagination: Pagination}> {
    return await apiGetPlans(pagination);
  }

  async register(plan: Plan): Promise<void> {
    return await apiPostPlan(plan);
  }

  async countByPage(): Promise<number> {
    return await apiGetPlansCount();
  }

  async update(plan: Plan): Promise<void> {
    return await apiPutPlan(plan);
  }

  async delete(planId: PlanId): Promise<void> {
    return await apiDeletePlan(planId);
  }

  async updateStatus(planId: PlanId, statusType: PlanStatusType): Promise<void> {
    return await apiPutPlanStatus(planId, statusType);
  }

  async findByReservationId(reservationId: ReservationId): Promise<Plan> {
    return await apiGetPlanReservationId(reservationId);
  }
}

export default PlanDataSource;
